module.exports = __webpack_public_path__ + "img/hamburger.9dd554d1.svg";